import { render, staticRenderFns } from "./DangerTask.vue?vue&type=template&id=96d1f3f2"
import script from "./DangerTask.vue?vue&type=script&lang=js"
export * from "./DangerTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DangerTask.vue?vue&type=custom&index=0&blockType=scoped"
if (typeof block0 === 'function') block0(component)

export default component.exports